/*@ngInject*/
export default ['$timeout', ($timeout) => {
    return {
        restrict: 'A',
        require: '^uiSelect',
        template: '<a class="btn btn-xs" style="margin-right:10px"><i class="material-icons" aria-hidden="true">clear</i></a>',
        replace: true,

        link: function (scope, element, attrs, $select) {

            element.on('click', (e) => {
                e.stopPropagation();
                $timeout(() => {
                    $select.selected = undefined;
                });
            });
        }
    };
}]
